<ng-container *transloco="let t">
    <div class="flex flex-row">
        <div class="px-4 sm:px-4 md:px-8 lg:px-8 p-2 sm:p-2 md:p-16 lg:p-16 map-background flex w-full">
            <div class="flex flex-col w-full">
                <div>
                    <div class="flex flex-row align-middle">
                        <hr class="bg-primary w-24">
                        <!-- Pre Title-->
                        <p class="ml-5 text-primary font-semibold mt-4">{{t(pretitle)}}</p>
                    </div>
                </div>
                <!-- Title-->
                <div class="mt-3 ml-4 font-medium text-3xl">{{t(title)}}</div>


                <!--switch layout buttons-->
                <div class="flex justify-end mt-8" *ngIf="mobile">
                    <mat-button-toggle-group aria-label="layoutStyle" #group="matButtonToggleGroup"
                                             [selected]="'layout'"
                                             (change)="switchView($event)">
                        <mat-button-toggle value="list" class="bg-primary text-black">
                            <mat-icon [svgIcon]="'heroicons_outline:view-list'" class="text-black"></mat-icon>
                            <span class="text-black">{{t('button-list')}}</span>
                        </mat-button-toggle>
                        <mat-button-toggle value="layout" class="bg-primary text-black">
                            <mat-icon [svgIcon]="'heroicons_outline:location-marker'" class="text-black"></mat-icon>
                            <span class="text-black">{{t('button-layout')}}</span>
                        </mat-button-toggle>
                    </mat-button-toggle-group>
                </div>

                <!--Schnellauswahl Standort: springt direkt zur Buchungsseite des Standorts-->
                <mat-form-field class="fuse-mat-no-subscript w-full sm:w-72 mt-3" *ngIf="mobile">
                    <input matInput #locationQuickSelectInput
                           [placeholder]="t('booking-select-location')"
                           [matAutocomplete]="locationQuickSelectAuto"
                           (focus)="onLocationFocus(locationQuickSelectInput)"
                           (input)="onLocationInput($event)">
                </mat-form-field>
                <mat-autocomplete #locationQuickSelectAuto="matAutocomplete"
                                   (optionSelected)="locationSelected($event.option.value, locationQuickSelectInput)">
                    <mat-option *ngFor="let location of filteredLocations" [value]="location">{{location?.name}}</mat-option>
                </mat-autocomplete>


                <div class="flex flex-row mt-8">
                    <div class="basis-full sm:basis-full md:basis-1/2 w-full h-full"
                         *ngIf="!mobile || mobile && mobileDisplay === 'layout'">
                        <google-map *ngIf="apiLoaded" [height]="!mobile ? '100%' : '60vh'" width="100%" [options]="options"  [center]="center">
                            <map-marker *ngFor="let marker of markers" [position]="marker.markerPosition"
                                        (mapClick)="markerClicked(marker)" (mapMouseover)="highlightList(marker)"
                                        [options]="markerOptions">
                            </map-marker>
                        </google-map>
                    </div>


                    <!-- Liste nur verstecken statt zerstören: das Owl-Carousel vermisst sich sonst beim Neuaufbau -->
                    <div class="basis-full sm:basis-full md:basis-1/2 lg:basis-1/2 min-w-0 mr-0 sm:mr-0 md:mr-4 lg:mr-8 lg:ml-4"
                         [ngClass]="{'hidden': mobile && mobileDisplay !== 'list'}">
                        <app-location-list [locations]="locations" [highlightListItem]="highlightItem"
                                           [userLocation]="userLocation" (panTo)="panTo($event)"></app-location-list>
                    </div>
                </div>
            </div>
        </div>


    </div>

</ng-container>
